import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormGroup,Validators as val } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { productName } from "../../../../admin/action/action";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { Validators } from "../../../../../shared/validators";
import { CustomValidators } from "../../../../../shared/custom-validators";
import { PromocodeModalComponent } from "../../../../admin/action/components/promocode/promocode-modal/promocode-modal.component";
import { CreatePromocodeService } from "../../services/create-promocode.service";
import { FetchSellerProductsService } from "../../services/fetch-seller-products.serivce";
import { GetPromocodeService } from "../../services/get-promo-code.service";
import { EditPromocodeService } from "../../services/edit-promo-code.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../../../../shared/services/language.service";
import { CONSTANT_PRODUCT_TYPE_INFOS } from "src/app/shared/constantProductTypeInfos";

@Component({
  selector: 'app-create-promocode',
  templateUrl: './create-promocode.component.html',
  styleUrls: ['./create-promocode.component.scss']
})
export class CreatePromocodeComponent implements OnInit, OnDestroy {
  Datenow = new Date();
  formValidator = new FormValidatorService();
  promoCodeFrom!: FormGroup;
  products: productWithType[] = [];
  validationError!: [
    {
      field: string,
      message: string;
      validation: string;
    }
  ];
  editMode: boolean = false;
  minQuantity: number = 1;
  selectedProudct = null;
  maxQuantity: number = 1000;
  productsSelectedInEdit: string = '';
  patternName: string = "^[_أ-يA-z0-9]*((-|s)*[_أ-يA-z0-9])*$";
  patternQuantity: string = "d{1,2}";
  subscription!: Subscription;
  productsIds: any[] = [];
  selectAll: boolean = false;
  productsIdsBeforAll: any[] = [];
  typeOptions = ['flat', 'percentage']
  typeTranslation = {
    flat: 'Sellers.Products.flatType',
    percentage: 'Sellers.Products.percentageType'
  }
  showTicketInput=false;
  eventType=CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.Event;
  showAvailableQuantity=true;
  constructor(
    public createPromo: CreatePromocodeService,
    public fetchProducts: FetchSellerProductsService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private getPromocodeService: GetPromocodeService,
    private editPromocodeService: EditPromocodeService,
    public translate: TranslateService,
    private languageService: LanguageService
  ) {}

  async ngOnInit() {
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
      this.translateValidationMessages();
    });
    this.activatedRoute.params.subscribe(async a => {
      if (a.id) {
        this.editMode = true;
        this.getPromocodeService.setParams({ codeName: a.id });
        const response = await this.getPromocodeService.make();
        //console.log(response);
        this.minQuantity = response.redeemedQuantity;
        this.selectedProudct = response.NewProductId;
        await this.initForm();

        this.promoCodeFrom.controls["codeName"].setValue(response.codeName);
        this.promoCodeFrom.controls["availableQuantity"].setValue(
          response.availableQuantity
        );

        this.promoCodeFrom.controls["precentage"].setValue(response.precentage);
        this.promoCodeFrom.controls["expiry"].setValue(response.expiry);
        this.promoCodeFrom.controls["type"].setValue(response.type);
        if (response.products) {
          this.productsIdsBeforAll = response.products.map((ele: any) => {
            return ele.NewProductId ? ele.NewProductId : 0
          });
          this.promoCodeFrom.controls["NewProductId"].setValue(this.productsIdsBeforAll);
          this.checkForEventSelected(this.productsIdsBeforAll);
          this.promoCodeFrom.controls["ticketQuantity"].setValue(response.ticketQuantity | 0)
          if (this.productsIdsBeforAll.indexOf(0) == -1) {
            this.productsSelectedInEdit = '';
            this.products.forEach(product => {
              if (this.productsIdsBeforAll.indexOf(product.id) > -1) {
                if (this.productsSelectedInEdit) this.productsSelectedInEdit += ' , ';
                this.productsSelectedInEdit += product.name;
              }
            });
          }
          if(response.products.length == 1 && response.products[0].NewProductId == null){
            this.productChange({value: [0]})
          }
        } else {
          this.promoCodeFrom.controls["NewProductId"].setValue(0);
        }
        if (response.description) {
          this.promoCodeFrom.controls["description"].setValue(
            response.description
          );
        }
      } else {
        this.initForm();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async initForm() {
    try {
      this.promoCodeFrom = this.formValidator.createForm([
        {
          fieldName: "codeName",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: ''
            },
            {
              validatorFn: Validators.minLength(2),
              message: ''
            },
            {
              validatorFn: CustomValidators.customPattern(/^\S*$/u),
              message: ''
            },
            {
              validatorFn: Validators.pattern(this.patternName),
              message: ''
            }
          ]
        },
        {
          fieldName: "availableQuantity",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: ""
            },
            {
              validatorFn: Validators.min(this.minQuantity),
              message: ``
            },
            {
              validatorFn: Validators.max(this.maxQuantity),
              message: ``
            }
          ]
        },
        {
          fieldName: "expiry",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: ""
            },
            {
              validatorFn: CustomValidators.dateInTheFuture,
              message: ""
            }
          ]
        },
        {
          fieldName: "NewProductId",
          defaultValue: this.selectedProudct,
          validators: [
            {
              validatorFn: Validators.required,
              message: "Products cannot be empty"
            }
          ]
        },
        {
          fieldName: "type",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: "Type cannot be empty"
            }
          ]
        },
        {
          fieldName: "description",
          defaultValue: null,
          validators: []
        },
        {
          fieldName: "precentage",
          defaultValue: null,
          validators: [
            {
              validatorFn: Validators.required,
              message: ""
            },
            {
              validatorFn: Validators.min(1),
              message: ""
            }
          ]
        },
        {
          fieldName: "ticketQuantity",
          defaultValue: null,
          validators: []
        },
      ]);
      this.translateValidationMessages();
      this.products = await this.fetchProducts.make();
      this.products.push({ id: 0, name: "All" });
      this.productsIds = this.products.map(ele => ele.id);
    } catch (err) { }
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        codeName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Promo Code',
            fieldAr: 'بروموكود'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Promo Code',
            fieldAr: 'بروموكود',
            value: 2
          }),
          customPattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Promo Code',
            fieldAr: 'بروموكود'
          }),
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Promo Code',
            fieldAr: 'بروموكود'
          }),
        },
        availableQuantity: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Quantity',
            fieldAr: 'العدد'
          }),
          min: this.translate.instant('FormValidation.Min', {
            field: 'Quantity',
            fieldAr: 'العدد',
            value: this.minQuantity
          }),
          max: this.translate.instant('FormValidation.Max', {
            field: 'Quantity',
            fieldAr: 'العدد',
            value: this.maxQuantity
          })
        },
        expiry: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Expiry',
            fieldAr: 'تاريخ الصلاحية'
          }),
          dateInTheFuture: this.translate.instant('FormValidation.DateInTheFuture'),
        },
        ticketQuantity: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Ticket Quantity',
            fieldAr: 'عدد التذاكر'
          }),
          min: this.translate.instant('FormValidation.Min', {
            field: 'Ticket Quantity',
            fieldAr: 'عدد التذاكر',
            value: this.minQuantity
          }),
          max: this.translate.instant('FormValidation.Max', {
            field: 'Ticket Quantity',
            fieldAr: 'عدد التذاكر',
            value: this.maxQuantity
          })
        },
        NewProductId: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Products',
            fieldAr: 'المنتجات'
          })
        },
        type: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Type',
            fieldAr: 'النوع'
          })
        },
        precentage: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Value',
            fieldAr: 'القيمة'
          }),
          min: this.translate.instant('FormValidation.Min', {
            field: 'Value',
            fieldAr: 'القيمة',
            value: 1
          }),
          max: this.translate.instant('FormValidation.Max', {
            field: 'Value',
            fieldAr: 'القيمة',
            value: 100
          })
        }
      }
    });
  }

  async onSubmit(promoCodeValues: any) {
    try {
      const isTicketOnly=!this.showAvailableQuantity &&this.showTicketInput;
      promoCodeValues = {
        ...promoCodeValues,
        isTicketOnly,
        availableQuantity: promoCodeValues.availableQuantity | 0,
        ticketQuantity: promoCodeValues.ticketQuantity | 0,
      };
      if (this.editMode) {
        promoCodeValues.ProductIds = [...promoCodeValues.NewProductId];
        delete promoCodeValues.NewProductId;
        if (promoCodeValues.ProductIds.indexOf(0) > -1) {
          promoCodeValues.ProductIds = [null];
        }
        this.editPromocodeService.setParams(promoCodeValues);
        await this.editPromocodeService.make();
      } else {
        this.editMode = false;
        console.log(promoCodeValues.codeName);
        promoCodeValues.ProductIds = [...promoCodeValues.NewProductId];
        delete promoCodeValues.NewProductId;
        if (promoCodeValues.ProductIds.indexOf(0) > -1) {
          promoCodeValues.ProductIds = [null];
        }
        this.createPromo.setParams(promoCodeValues);
        await this.createPromo.make();

        const dialogRef = this.dialog.open(PromocodeModalComponent, {
          width: "400px",
          data: {
            name: promoCodeValues.codeName
          }
        });
        await dialogRef.afterClosed().toPromise();

        this.snackbar.open(
          this.translate.instant('Sellers.Products.PromoCodeCreated', {
            field: promoCodeValues.codeName,
          }),
          '',
          { duration: 3000 }
        );
      }
      this.router.navigate(["/seller/promo-code/manage"]);
    } catch (err) {
      if(err.faultyRequest){
      console.log(err.faultyRequest.error.message, 'err');
      this.promoCodeFrom.controls['codeName'].setErrors({ invalid: err.faultyRequest.error.message });
      this.formValidator.ShowErrors();
      this.formValidator.formErrors['codeName'] = err.faultyRequest.error.message;
      }
      this.validationError = err.validationErrors.error;
      for (const e of this.validationError) {
        this.formValidator.addError(e.field, "invalid", e.message);
        this.promoCodeFrom.controls[e.field].setErrors({ invalid: e.message });
        this.formValidator.ShowErrors();
      }
    }
  }

  productChange(event: any) {
    if (event.value.indexOf(0) > -1) {// wen seller check all make all products selected
      this.productsIds
      this.promoCodeFrom.controls['NewProductId'].setValue(this.productsIds);
      this.selectAll = true;
      this.showTicketInput=true;
      this.showAvailableQuantity=true;
      this.handleInput('ticketQuantity', this.showTicketInput);
      this.handleInput('availableQuantity', this.showAvailableQuantity);
    } else if (this.selectAll) {// wen seller uncheck all make all products selected
      const isProductsIdsBeforeAllHasSelectAll = this.productsIdsBeforAll?.[0] == 0;
      this.productsIdsBeforAll = isProductsIdsBeforeAllHasSelectAll ? [] : this.productsIdsBeforAll;
      this.promoCodeFrom.controls['NewProductId'].setValue(this.productsIdsBeforAll);
      this.selectAll = false;
    } else {// wen seller check anu productadd it to controller value
      this.productsIdsBeforAll = event.value;
      this.promoCodeFrom.controls['NewProductId'].setValue(this.productsIdsBeforAll);
    }
    if(!this.selectAll) this.checkForEventSelected(this.productsIdsBeforAll);

  }
  handleTypeValidation(event: {source:any,value:string}){
    this.promoCodeFrom.controls['precentage'].clearValidators();
    if (event.value == 'flat') {
      this.promoCodeFrom.get('precentage').setValidators([
        val.required,
        val.min(1),
      ]);
      document.getElementById('flatOptionMsg').innerHTML = this.translate.instant('Sellers.Products.msg_flat_otpion')
    } else {
      this.promoCodeFrom.get('precentage').setValidators([
        val.required,
        val.min(1),
        val.max(100),
      ]);
      document.getElementById('flatOptionMsg').innerHTML =""
    }
    this.promoCodeFrom.controls['precentage'].updateValueAndValidity();
  }
  checkForEventSelected(productIds:number[]){
    this.showTicketInput = false;
    let eventsCount = 0;
    for (const prodId of productIds) {
      const selectedProd = this.products.find((prod) => prod.id == prodId);
      if (this.isTicketQuantity(selectedProd.type)) {
        this.showTicketInput = true;
        eventsCount += 1;
      }
    }
    if (eventsCount == productIds.length) {
      this.showAvailableQuantity = false;
    } else {
      this.showAvailableQuantity = true;
    }
    this.handleInput('ticketQuantity', this.showTicketInput);
    this.handleInput('availableQuantity', this.showAvailableQuantity);
  }
  handleInput(key:string,showInput:boolean){
    this.promoCodeFrom.get(key).clearValidators();
    if(showInput){
      this.promoCodeFrom.get(key).setValidators([val.required,val.min(this.minQuantity),val.max(this.maxQuantity)]);
      this.formValidator.formErrors[key] = "";
    }else{
      this.promoCodeFrom.get(key).clearValidators();
      this.promoCodeFrom.get(key).setValue(null);
      delete this.formValidator.formErrors[key];
    }
    this.promoCodeFrom.get(key).updateValueAndValidity();

  }
  isTicketQuantity (type:string){
    if (
      type === CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.Event ||
      type === CONSTANT_PRODUCT_TYPE_INFOS.PRODUCT_TYPES.Reservation
      ) return true
    return false
  }
}
interface productWithType extends productName{

  type?:string;
}
